import { isValidFilename } from './string';

const mediaFilePathPrefix = '/papi/media/file/';

export const normalizeMediaFileUrl = (url?: string | null): string | undefined => {
  if (!url || !url.startsWith(mediaFilePathPrefix)) {
    return url ?? undefined;
  }

  const [urlWithoutHash] = url.split('#');
  const [urlWithoutQuery] = urlWithoutHash.split('?');

  return urlWithoutQuery;
};

export const getMediaFilenameFromUrl = (url?: string | null): string | null => {
  const normalizedUrl = normalizeMediaFileUrl(url);

  if (!normalizedUrl || !normalizedUrl.startsWith(mediaFilePathPrefix)) {
    return null;
  }

  const encodedFilename = normalizedUrl.slice(mediaFilePathPrefix.length);
  const decodedFilename = encodedFilename ? decodeURIComponent(encodedFilename) : null;

  return decodedFilename && isValidFilename(decodedFilename) ? decodedFilename : null;
};
